import { takeLatest, call, put } from "redux-saga/effects"
import axios from "axios"
import { message } from "antd"
import { push } from "connected-react-router"

import {
  GET_SUMMARY_WATCHER,
  UPLOAD_TEMPLATE_WATCHER,
  SAVE_EXCEL_WATCHER,
} from "./constants"

import {
  getSummarySuccess,
  getSummaryFailed,
  uploadTemplateFailed,
  uploadTemplateSuccess,
  saveExcelProgress,
  saveExcelSuccess,
} from "./actions"
import { LOCAL_TOKEN } from "../../utils/storage"

function messageProgress(messagex) {
  message.loading(messagex, 0)
}

function messageSuccess(messagex) {
  message.success(messagex, 5)
}

function messageFailed(messagex) {
  message.error(messagex, 5)
}

function messageDestroy() {
  message.destroy()
}

// GET SUMMARY
function getSummaryApi(payload) {
  const measureId = localStorage.getItem("currentMeasure")
  const token = LOCAL_TOKEN()
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${token}` },
    url: `${process.env.API_URL}action-plans/measure/${measureId}/import/xlsx/summary`,
    params: payload,
  })
}

function* getSummary() {
  try {
    const search = window.location.search
    const queryParams = new URLSearchParams(search)

    let timestamp = {
      timestamp: queryParams.get("time"),
    }
    const { data, status } = yield call(getSummaryApi, timestamp)
    if (status === 200) yield put(getSummarySuccess(data[0]))
  } catch (error) {
    yield put(getSummaryFailed())
  }
}

// UPLOAD EXCEL
function uploadTemplate(payload) {
  const measureId = localStorage.getItem("currentMeasure")
  const token = LOCAL_TOKEN()
  return axios.request({
    method: "post",
    url: `${process.env.API_URL}action-plans/measure/${measureId}/import/xlsx`,
    headers: { Authorization: `Bearer ${token}` },
    data: payload,
  })
}

function uploadTemplateProgress(payload) {
  const measureId = localStorage.getItem("currentMeasure")
  const token = LOCAL_TOKEN()
  return axios.request({
    method: "get",
    url: `${process.env.API_URL}action-plans/measure/${measureId}/import/xlsx/progress`,
    headers: { Authorization: `Bearer ${token}` },
    params: payload,
    validateStatus: (status) => true,
  })
}

export function* uploadTemplateWatcher(action) {
  try {
    yield call(messageProgress, "Cargando archivo")

    const uploadData = yield call(uploadTemplate, action.payload)
    let timestamp = { timestamp: uploadData.data.timestamp }
    const measureId = localStorage.getItem("currentMeasure")

    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))

      data = yield call(uploadTemplateProgress, timestamp)

      if (data.status === 200) {
        yield call(messageDestroy)
        yield put(
          push(
            `/action-plans/import/${measureId}/summary?time=${timestamp.timestamp}`
          )
        )
        yield call(getSummary)
        yield call(messageSuccess, "Archivo importado")
        yield put(uploadTemplateSuccess(data.data))
        break
      }
      if (data.status === 500 || data.status === 400 || data.status === 404) {
        yield call(messageDestroy)
        yield call(messageFailed, data.data.data.error.status)
        yield put(uploadTemplateFailed())
        break
      }
    }
  } catch (error) {
    yield put(uploadTemplateFailed())
    yield call(messageDestroy)
    yield call(messageFailed, "Error al importar archivo")
  }
}

// SAVE EXCEL
function saveExcelApi(payload) {
  const measureId = localStorage.getItem("currentMeasure")
  const token = LOCAL_TOKEN()
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${token}` },
    url: `${process.env.API_URL}action-plans/measure/${measureId}/import/xlsx/confirm`,
    params: payload,
    validateStatus: (status) => true,
  })
}

function saveExcelProgressApi(payload) {
  const measureId = localStorage.getItem("currentMeasure")
  const token = LOCAL_TOKEN()
  return axios.request({
    method: "get",
    url: `${process.env.API_URL}action-plans/measure/${measureId}/import/xlsx/confirm/progress`,
    headers: { Authorization: `Bearer ${token}` },
    params: payload,
    validateStatus: (status) => true,
  })
}

export function* saveExcelSaga(action) {
  try {
    yield call(saveExcelApi, action.payload)
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 200))
      data = yield call(saveExcelProgressApi, action.payload)
      if (data.status === 202) {
        yield put(saveExcelProgress(data.data.data.result[0].percentage))
      }
      if (data.status === 200) {
        yield put(saveExcelProgress(100))
        yield put(saveExcelSuccess(data))
        break
      }
    }
  } catch (error) {
    returnMessage(error)
  }
}

// Individual exports for testing
export default function* actionPlansImportSummarySaga() {
  yield takeLatest(SAVE_EXCEL_WATCHER, saveExcelSaga)
  yield takeLatest(GET_SUMMARY_WATCHER, getSummary)
  yield takeLatest(UPLOAD_TEMPLATE_WATCHER, uploadTemplateWatcher)
}
